

import React from 'react';
import axios from 'axios';


import Image from 'react-bootstrap/Image';
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import ResendLink from '../../Shared/ResendLink';
import ToyotaLogo from '../../../../static/images/ty-login-logo.png'
import Loader from '../../../../static/images/loading.gif'
import AppVars from '../../../../AppVars.js'
import Logger from '../../../../Logger.js';
import { constants } from '../../../../constants/constants';
import returnHeader from './ResendPasswordFormHeaders'


let appVars = AppVars.getInstance();

class ResendPasswordFormView extends React.Component {

    constructor(props){
        super(props);
        this.state = {
            ...props,
        }
    }

    render() {
        return(
            <div>
                <div role="banner">
                {/* HEADER AND TITLE RENDERING BASED ON STATE */}
                <div>
                <a href = {appVars.getAppHomeURL(this.props.style)}><Image className="login-log-resend" src={require('../../../../static/images/Toyota-Logo.svg').default} alt="Toyota"/></a>
                </div>
                <div>
                {returnHeader(this.props.showForm)}
                </div>
                <div class="message__TO">{constants.PASSWORD_ERROR_SUBTITLE}</div>
                </div>

                    <div>
                        <Form id='activateEmail__TO' onSubmit={this.props.processEmail}>
                                <Form.Group className = "relative">
                                <Form.Label className = {`${this.props.floatEmail === true ? "absolute floating-label" : "absolute inline-label" }
                                ${this.props.emailFocus === true ? "label-black__TO" : "" }
                                ${this.props.isEmailValid === false && this.props.emailFocus === false ? "label-red__TO" : ""}
                                `}>
                    Email
                    <span id="redStar">*</span></Form.Label>
                                    <Form.Control
                                        id='email__TO'
                                        data-testid='email'
                                        aria-label='Email'
                                        as='input'
                                        type='text'
                                        name='email'
                                        placeholder=''
                                        value = {this.props.email}
                                        onChange = {this.props.handleEmailChange}
                                        onFocus = {this.props.onFocusEmail}
                                        onBlur = {this.props.onBlurEmail}
                                        bsPrefix = {`${this.props.isEmailValid === false && this.props.emailFocus === false ? "highlight-error__TO form-control" : ""}`}
                                    />
                                </Form.Group>
                                <div
                                    id = "emailValidationAlert"
                                    data-testid = "emailValidationError"  
                                    className = {`logon-item-error__TO ${this.props.isEmailValid === false && this.props.emailFocus === false ? "block" : "none"}`}
                                    role = "alert" 
                                    aria-hidden = {`${this.props.isEmailValid === false && this.props.emailFocus === false ? "false" : "true"}`}
                                >
                                    Please enter a valid email address
                                </div>
                                <Button style = {{"marginTop" : "30px"}} id='resend-button' data-testid = "activateEmailButton" bsPrefix = "button__TO" type = "submit" >Email Me</Button>
                        </Form>
                    </div>

                {/* Links */}
                {/* <div role = "complementary">
                <ResendLink
                        lineText="Don't have a Toyota account yet??"
                        linkAddress="/register"
                        linkText="JOIN NOW"
                        className="resend-link inline-block"
                    />

                <ResendLink
                        lineText="Already have a Toyota account?"
                        linkAddress="/"
                        linkText="SIGN IN"
                        className="resend-link inline-block"
                    />
                <ResendLink
                        lineText="Need help?"
                        linkAddress="/"
                        linkText="CONTACT US"
                        className="resend-link inline-block"
                    />
                </div> */}
                <div className={`${this.props.loadingReset === true ? "resend-background" : "none" }`}>
                    <div className="spinner">
                        <img className='spinner-img' src={Loader} alt="Loading"/>
                    </div>
                </div>
            </div>
        )
    }

}

export default ResendPasswordFormView
